import {
  enable,
  disable,
  setConfiguration,
  getConfiguration,
} from './stackPrefetch';

export { enable, disable, setConfiguration, getConfiguration };
